/**
 * In-memory flag so Header can block navigation while the integration
 * Settings tab holds pending (unsaved) changes. Updated by the
 * PendingChangesProvider; cleared on its unmount.
 */
let unsaved = false;

export function setIntegrationsSettingsUnsaved(dirty: boolean): void {
  unsaved = dirty;
}

export function getIntegrationsSettingsUnsaved(): boolean {
  return unsaved;
}
